export enum ETacticColumnNodeStatus {
  Covered = 'Covered',
  NotCovered = 'NotCovered',
  OtherContent = 'OtherContent'
}
